import { Facebook, Instagram, Youtube, Linkedin, MapPin, Phone, Mail } from "lucide-react";

const LOGO =
    "https://customer-assets.emergentagent.com/job_2dd4774c-00c6-45cd-8263-5e60a2df322d/artifacts/jfrbne5i_WhatsApp%20Image%202026-04-24%20at%204.31.50%20PM.jpeg";

const QUICK = [
    { label: "About", href: "#about" },
    { label: "Course", href: "#course" },
    { label: "Admission", href: "#admission" },
    { label: "Gallery", href: "#gallery" },
    { label: "Contact", href: "#contact" },
];

const STUDENT = [
    "Scholarship & SCC",
    "Placement Support",
    "Anti-Ragging Cell",
    "Career Guidance Cell",
];

export const Footer = () => (
    <footer
        data-testid="site-footer"
        className="relative pt-20 pb-10 text-stone-100"
        style={{ background: "linear-gradient(180deg, #0E5C2D 0%, #0A4622 100%)" }}
    >
        <div className="max-w-7xl mx-auto px-5 md:px-8 lg:px-12">
            <div className="grid md:grid-cols-2 lg:grid-cols-12 gap-10">
                <div className="lg:col-span-5">
                    <div className="flex items-center gap-3">
                        <img src={LOGO} alt="Logo" className="w-14 h-14 rounded-full object-cover ring-2 ring-white/30" />
                        <div>
                            <div className="font-display text-2xl text-white">Prasad Rudrik</div>
                            <div className="text-[11px] uppercase tracking-[0.18em] text-white/70">
                                College of Pharmaceutical Sciences
                            </div>
                        </div>
                    </div>
                    <p className="mt-5 text-sm text-white/75 leading-relaxed max-w-md">
                        A unit of Prasad Educational Trust — committed to producing skilled,
                        compassionate pharmacy professionals for community healthcare across India.
                    </p>
                    <div className="mt-6 flex items-center gap-3">
                        {[
                            { icon: Facebook, label: "Facebook" },
                            { icon: Instagram, label: "Instagram" },
                            { icon: Youtube, label: "YouTube" },
                            { icon: Linkedin, label: "LinkedIn" },
                        ].map(({ icon: Icon, label }) => (
                            <a
                                key={label}
                                href="#"
                                aria-label={label}
                                data-testid={`footer-social-${label.toLowerCase()}`}
                                className="w-10 h-10 rounded-full border border-white/25 flex items-center justify-center hover:bg-[var(--brand-yellow)] hover:text-stone-900 hover:border-[var(--brand-yellow)] transition-all"
                            >
                                <Icon size={16} />
                            </a>
                        ))}
                    </div>
                </div>

                <div className="lg:col-span-2">
                    <div className="text-xs uppercase tracking-[0.2em] text-[var(--brand-yellow)]">Quick Links</div>
                    <ul className="mt-5 space-y-3">
                        {QUICK.map((q) => (
                            <li key={q.label}>
                                <a
                                    href={q.href}
                                    data-testid={`footer-link-${q.label.toLowerCase()}`}
                                    className="text-sm text-white/80 hover:text-white link-underline"
                                >
                                    {q.label}
                                </a>
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-2">
                    <div className="text-xs uppercase tracking-[0.2em] text-[var(--brand-yellow)]">Students Corner</div>
                    <ul className="mt-5 space-y-3">
                        {STUDENT.map((s) => (
                            <li key={s} className="text-sm text-white/80">
                                {s}
                            </li>
                        ))}
                    </ul>
                </div>

                <div className="lg:col-span-3">
                    <div className="text-xs uppercase tracking-[0.2em] text-[var(--brand-yellow)]">Contact</div>
                    <ul className="mt-5 space-y-4 text-sm text-white/85">
                        <li className="flex gap-3 items-start">
                            <MapPin size={16} className="text-[var(--brand-yellow)] mt-0.5" />
                            <span>
                                Vill + P.O. Kanachi, P.S. Mallarpur, Dist. Birbhum, West Bengal — 731216
                            </span>
                        </li>
                        <li className="flex gap-3 items-center">
                            <Phone size={16} className="text-[var(--brand-yellow)]" />
                            <a href="tel:8637584851" className="hover:text-white">8637584851 / 8509650147</a>
                        </li>
                        <li className="flex gap-3 items-start">
                            <Mail size={16} className="text-[var(--brand-yellow)] mt-0.5" />
                            <a
                                href="mailto:prasadeducationaltrust2021@gmail.com"
                                className="break-all hover:text-white"
                            >
                                prasadeducationaltrust2021@gmail.com
                            </a>
                        </li>
                    </ul>
                </div>
            </div>

            <div className="mt-14 pt-6 border-t border-white/15 flex flex-wrap items-center justify-between gap-4 text-xs text-white/60">
                <div>
                    © {new Date().getFullYear()} Prasad Rudrik College of Pharmaceutical Sciences. All
                    rights reserved.
                </div>
                <div>
                    A Unit of Prasad Educational Trust • prasadrudrikcollegeofpharmaceuticalsciences.com
                </div>
            </div>
        </div>
    </footer>
);

export default Footer;
